//@ts-nocheck
import { AppSetting } from '@/Interfaces/models';
import { useThemeStore } from '@/stores/theme';
import { applyPrimaryTheme } from '@/utils/apply-primary-theme';
import type { Page, PageProps } from '@inertiajs/core';
import { usePage } from '@inertiajs/vue3';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

export default () => {
  interface MyPageProps extends PageProps {
    app_settings: AppSetting;
  }
  const page: Page<MyPageProps> = usePage();

  const primaryColor = computed(
    () => page.props.app_settings?.color ?? '#0069b4',
  );

  const store = useThemeStore();
  const { basePrimary, currentPrimary } = storeToRefs(store);

  const load = (customColor?: string) => {
    const color = customColor ?? primaryColor.value;
    basePrimary.value = color;
    currentPrimary.value = applyPrimaryTheme(color);
  };

  return { load, primaryColor };
};
